
import { Separator } from '@/components/ui/separator';
import { TERMS_OF_SERVICE } from '@/data/termsOfService';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto font-poppins-regular">
      <h1 className="text-3xl font-poppins-bold mb-6">Felhasználási Feltételek</h1>
      <Separator className="mb-8" />
      {TERMS_OF_SERVICE.sections.map((section, index) => (
        <section key={index} className="mb-6">
          <h2 className="text-xl font-poppins-semibold mb-4">{section.title}</h2>
          <p className="text-gray-700 mb-4">{section.content}</p>
        </section>
      ))}
      <div className="mt-8 text-sm text-gray-500">
        <p>Utolsó frissítés: {TERMS_OF_SERVICE.lastUpdated}</p>
      </div>
    </div>
  );
};

export default TermsOfService;
